import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import { Providers } from '@/app/Providers';
import '@/lib/sentry';
import { RouterProvider } from '@/routes';

import './lib/i18n/client';
import './prototypes/string';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <Providers>
      <RouterProvider />
    </Providers>
  </StrictMode>
);

if (import.meta.hot) {
  import.meta.hot.dispose(() => root.unmount());
}
